export default "__VITE_ASSET__ef33468d__"